import { render, staticRenderFns } from "./MsgElementCard.vue?vue&type=template&id=344cb0a4&scoped=true"
import script from "./MsgElementCard.vue?vue&type=script&lang=js"
export * from "./MsgElementCard.vue?vue&type=script&lang=js"
import style0 from "./MsgElementCard.vue?vue&type=style&index=0&id=344cb0a4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "344cb0a4",
  null
  
)

export default component.exports